module.exports = __webpack_public_path__ + "img/legume-peanuts-190x100.9b36a112.jpg";